module.exports = __webpack_public_path__ + "media/images/dine-81c7b9a1f29b4c1b740140943aad3ef3.png";